import { toastOptions } from '@/lib/data/toast-options';

export const notify = {
    methods: {
        // Just message = message + default options
        // Message + options = Message + overridden options
        // Message + options + bool = message + default options + overridden options
        // Hope that makes sense!
        notify(message = '', options = toastOptions, isAppending = false) {
            let settings = isAppending
                ? {
                      ...toastOptions,
                      ...options,
                  }
                : options;

            this.$toasted.show(message, settings);
        },
    },
};
